export default __webpack_public_path__ + "static/media/ONBOARDINGICONA.ad2f47c3.svg";